import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Two small dropdowns shared by the candidate + employer bulk-email composers:
 *  1. "Load a template" — pick a saved email template to prefill subject/body.
 *  2. "From" — choose which team member the email is sent as.
 */
export function EmailComposerExtras({ pw, brand = "careers", senderEmail, onSender, selectedKey = "", onLoadTemplate }) {
  const [templates, setTemplates] = useState([]);
  const [senders, setSenders] = useState([]);

  useEffect(() => {
    const headers = { "X-Admin-Password": pw };
    axios
      .get(`${API}/api/admin/email-hub/templates?brand=${brand}`, { headers })
      .then((r) => setTemplates(r.data?.templates || []))
      .catch(() => {});
    axios
      .get(`${API}/api/admin/email-hub/senders`, { headers })
      .then((r) => setSenders(r.data?.senders || []))
      .catch(() => {});
  }, [pw, brand]);

  const defaultFrom = brand === "careers" ? "info@theditchcareers.com.au" : "info@theditchcollective.co.nz";
  const selectCls =
    "w-full text-sm rounded-lg border border-[#D6DCE3] px-3 py-2 bg-white outline-none focus:border-[#0D2F4D]";
  const labelCls = "block text-[11px] font-bold uppercase tracking-wide text-[#6F8FA8] mb-1";

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <label className={labelCls}>Load a template</label>
        <select
          data-testid="bulk-email-template-select"
          value={selectedKey}
          onChange={async (e) => {
            const key = e.target.value;
            if (!key) { onLoadTemplate?.(null); return; }
            try {
              const headers = { "X-Admin-Password": pw };
              const [detail, preview] = await Promise.all([
                axios.get(`${API}/api/admin/email-hub/templates/${key}`, { headers }),
                axios.post(`${API}/api/admin/email-hub/preview`, { template_key: key }, { headers }),
              ]);
              onLoadTemplate?.({ ...detail.data, preview_html: preview.data?.html || "" });
            } catch (_) {
              const fallback = templates.find((x) => x.key === key);
              if (fallback) onLoadTemplate?.(fallback);
            }
          }}
          className={selectCls}
        >
          <option value="">— Start from scratch —</option>
          {templates.map((t) => (
            <option key={t.key} value={t.key}>{t.name || t.subject || t.key}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={labelCls}>From</label>
        <select
          data-testid="bulk-email-sender-select"
          value={senderEmail || ""}
          onChange={(e) => onSender?.(e.target.value)}
          className={selectCls}
        >
          <option value="">Brand default ({defaultFrom})</option>
          {senders.map((s) => (
            <option key={s.email} value={s.email}>
              {s.name} ({brand === "careers" ? s.careers_from : s.collective_from})
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
